import { DetailedInsight } from '@toggle/toggle';
import React from 'react';

import { InsightCardDetails } from '~/components/insight-card-details/InsightCardDetails';

import styles from './InsightSummary.module.scss';

export interface InsightSummaryProps {
  insight: DetailedInsight;
  isFixedIncome: boolean;
}

export const InsightSummary = ({
  insight,
  isFixedIncome,
}: InsightSummaryProps) => (
  <div className={styles.insightSummaryRoot} data-testid="insight-summary">
    <div className={styles.insightCardWrapper}>
      <InsightCardDetails
        qualityStars={insight.metadata.stars}
        median={insight.metadata.median_return}
        horizon={insight.metadata.horizon}
        isFixedIncome={isFixedIncome}
      />
    </div>
  </div>
);
